import { Helper } from '../Helper';
export class StructuredStorageBaseHelper extends Helper {
    constructor({ type }) {
        super();
        this.type = type;
    }
}

//# sourceMappingURL=StructuredStorageBaseHelper.js.map
